import styled from "styled-components";
import { getHexOpacity } from "../../../utils/pipes";

export const Emr = styled.div`
  background-color: #e3e4ee;
  height: 100%;
  .emr-content {
    height: calc(100% - 76px );
    display: flex;
    background-color: red;
    &__left {
      width: 30%;
      padding: 0 0 10px 20px;
      box-sizing: border-box;
    }
    &__right {
      padding: 0 20px 10px 10px;
      width: 70%;
      display: flex;
      flex-direction: column;
      align-items: center;
      box-sizing: border-box;
    }
  }
`;